import React, { createContext, useContext, useState } from 'react';

const SearchContext = createContext();

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch must be used within SearchProvider');
  }
  return context;
};

export const SearchProvider = ({ children }) => {
  const [globalSearchQuery, setGlobalSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchPlaceholder, setSearchPlaceholder] = useState('Search...');

  return (
    <SearchContext.Provider 
      value={{ 
        globalSearchQuery, 
        setGlobalSearchQuery,
        searchResults,
        setSearchResults,
        searchPlaceholder,
        setSearchPlaceholder
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};
